import React, { memo } from 'react';
import './_aboutBannerBlock.scss';
import { Link } from 'react-router-dom';

const AboutBannerBlock = ({ banner }) => {

  return <>
        <section className='banner-section mb-0 about-page-banner videoBanner' id='history'>
            <div style={{ backgroundImage: `url(${banner?.url})` }} className='banner-img d-none d-md-block'>
                <Link to='/' className='banner-logo'>
                    <img src='/media/images/InClassica_White.svg' alt='logo'/>
                </Link>
                <div className='banner-container'>
                    <div className='banner-context about-context white left' dangerouslySetInnerHTML={{ __html: banner?.text }}/>
                </div>
            </div>


            <div style={{ backgroundImage: `url(${banner?.mobile_url})` }} className='banner-img d-md-none d-block'>
                <Link to='/' className='banner-logo'>
                    <img src='/media/images/InClassica_White.svg' alt='logo'/>
                </Link>
                <div className='banner-container'>
                    <div className='banner-context about-context white left' dangerouslySetInnerHTML={{ __html: banner?.text }}/>
                </div>
            </div>
        </section>
  </>;
};

export default memo(AboutBannerBlock);
